var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSustainabilityShape1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.32 267.33"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SustainabilityShape1_svg__SustainabilityShape1Mask",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.982.459L.745.032A.061.111 0 00.681.007L.038.464a.059.108 0 00-.038.1v.328C0 .952.027 1 .06 1h.88C.973 1 1 .952 1 .892V.535A.058.107 0 00.982.459"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OTAuMzIgMjY3LjMzIj4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iU3VzdGFpbmFiaWxpdHlTaGFwZTFNYXNrIiBjbGlwUGF0aFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+CiAgICAgIDxwYXRoIGQ9Ik0wLjk4MiwwLjQ1OSwwLjc0NSwwLjAzMiBBMC4wNjEsMC4xMTEsMCwwLDAsMC42ODEsMC4wMDcgTDAuMDM4LDAuNDY0IEEwLjA1OSwwLjEwOCwwLDAsMCwwLDAuNTY0IHYwLjMyOCBjMCwwLjA2LDAuMDI3LDAuMTA4LDAuMDYsMC4xMDggSDAuOTQgYzAuMDMzLDAsMC4wNiwtMC4wNDgsMC4wNiwtMC4xMDggVjAuNTM1IEEwLjA1OCwwLjEwNywwLDAsMCwwLjk4MiwwLjQ1OSIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgSustainabilityShape1 as ReactComponent };